export enum GlobalErrorType {
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  UNKNOW = 'UNKNOW',
}
